import axios from 'axios'

export const createDonation = async (data:any) => {
  const url = '/api/v1/donation'
  const createDonationResponse = await axios.post(url, data, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
  .then((response:any) => {
    return response
  })
  .catch((error:any) => {
    return error.response
  })
  return createDonationResponse
}

export const saveDonation = async (data:any) => {
  const url = `/api/v1/donation/${data.public_id}`
  const recaptchaToken = ''; // NOTE: recaptacha can be added here
  const saveDonationResponse = await axios.put(url, data, {
    headers: {
      'Content-Type': 'application/json',
      'User-Response': `${ recaptchaToken }`
    }
  })
  .then((response:any) => {
    return response
  })
  .catch((error:any) => {
    return error.response
  })
  return saveDonationResponse
}


export const getTitles = async () => {
  let titles = await axios.get('/api/v1/settings')
  return JSON.parse(titles.data[0].titles)
}
